import { axios } from "@/core/axios";
import { config } from "@/config/env";
import { CreateWidgetRequest, CreateWidgetResponse, DeleteWidgetResponse, RefineWidgetRequest, Widget } from "../types";

export const widgetEndpoints = {
    createWidget: async (props: { prompt: string; dashboardId: number; clientId: number; pageId: number }): Promise<CreateWidgetResponse | undefined> => {
        try {
            const requestBody: CreateWidgetRequest = {
                clientId: props.clientId,
                agentId: config.AGENT_ID,
                agentAliasId: config.AGENT_ALIAS_ID,
                prompt: props.prompt,
                dashboardId: Number(props.dashboardId),
                pageId: Number(props.pageId),
            };

            const response = await axios.post<CreateWidgetResponse>("/agent", requestBody);

            return response.data;
        } catch (error) {
            console.error("Error creating widget:", error);
            throw error;
        }
    },
    refineWidget: async ({ prompt, widget }: RefineWidgetRequest) => {
        try {
            const response = await axios.post<CreateWidgetResponse>("/refine-widget", {
                prompt,
                widget,
            });

            return response.data;
        } catch (error) {
            console.error("Error creating widget:", error);
            throw error;
        }
    },

    createManualWidget: async (widgetData: {
        title: string;
        description: string;
        type: string;
        pageId: number;
        service: any;
        tag?: string | null;
        chartType?: string;
        metrics?: string[];
        breakdownBy?: string;
        widgetInfo?: string;
        expandable?: boolean;
        colors?: string[];
        datePeriod?: string;
    }): Promise<{ success: boolean; widget: Widget }> => {
        try {
            const response = await axios.post<{ success: boolean; widget: Widget }>("/widget", widgetData);
            return response.data;
        } catch (error) {
            console.error("Error creating manual widget:", error);
            throw error;
        }
    },

    updateWidget: async (widget: Widget) => {
        try {
            const response = await axios.put<{ success: boolean; widget: Widget }>("/widget", widget);
            return response.data;
        } catch (error) {
            console.error("Error updating widget:", error);
            throw error;
        }
    },

    deleteWidget: async (props: { widgetId: number }) => {
        try {
            return await axios.delete<DeleteWidgetResponse>(`/widget`, { params: { widgetId: props.widgetId } });
        } catch (error) {
            console.error("Error deleting widget:", error);
            throw error;
        }
    },
    getWidgetInsights: async (widget: Widget & { data?: any }) => {
        try {
            const response = await axios.post<{ success: boolean; message: string; insights: string; recommendations: string }>("/widget-insights", widget);
            return response.data;
        } catch (error) {
            console.error("Error getting insights:", error);
            throw error;
        }
    },
};
